import { ProcedureBridgeApi } from 'client/components/schema/procedure-bridge/ProcedureBridgeApi';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { AlertPage } from 'client/ui/alert/AlertPage';
import { LoadingPage } from 'client/ui/loader/LoadingPage';
import React from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import { RequestDocumentBasePage } from './RequestDocumentBasePage';

interface Params {
  id: string;
}

export interface RequestMainDocumentPageProps
  extends RouteComponentProps<
    Params,
    StaticContext,
    { token: string | null }
  > {}

export function RequestMainDocumentPage(props: RequestMainDocumentPageProps) {
  const id = props.match.params.id ? parseInt(props.match.params.id, 10) : null;
  const stateToken = props.location?.state?.token;

  // Se non presente nell'URL (ex. main document di una domanda a fascicolo singolo)
  // vado a prendere il token dall'API.
  const documentToken = useApiQuery(ProcedureBridgeApi.getDocumentToken, {
    data: { requestId: id! },
    skip: id == null || stateToken != null
  });

  const token = stateToken ?? documentToken.response?.data.token;

  if (documentToken.loading) return <LoadingPage />;

  if (documentToken.error || !token)
    return (
      <AlertPage
        showIcon
        type="error"
        message="Impossibile caricare il documento"
        description={getNetworkErrorMessage(
          documentToken.error,
          'Si è verificato un errore. Riprovare.'
        )}
      />
    );

  return <RequestDocumentBasePage {...props} id={id} token={token} />;
}
